<template>
	<div class="order-stage" style="min-height: 300px;" v-bind:class="{
		cancelled: cancelled,
	}">
		<div v-if="loading">
			Loading
		</div>
		<div v-else>
			<div class="margin-bottom">
				<button
					v-if="expandableItems > 0"
					class="small small-margin-right"
					v-on:click="expanded = !expanded">
						{{ !expanded ? 'Expand (+' + expandableItems + ')' : 'Collapse' }}
				</button>
				<button class="small" v-on:click="reload()">Reload</button>
			</div>
			<!-- <div class="reload-button">
				<button v-on:click="reload()">Reload</button>
			</div> -->

			<div v-if="cancelled" class="cancelled-label">
				<div>Cancelled</div>
			</div>

			<Modal v-if="inspect" v-on:close="inspect = false;">
				<Json :data="inspect" />
			</Modal>

			<div class="groups" v-bind:class="{
				'no-items': !usingItems,
			}">

				<div v-for="group in data" class="group" v-bind:class="{
						completed: group.completed,
						failed: isFailed(group),
						warning: isWarning(group),
					}">
					<div class="name">
						<div class="circle">
							<SvgIcon v-if="group.completed" name="done" />
							<SvgIcon v-if="isWarning(group)" name="exclamation" />
							<SvgIcon v-if="isFailed(group)" name="close" />
						</div>
						{{ group.name }}
					</div>
					<div class="items">
						<div
							v-for="item in group.items"
							v-if="!item.collapsible || expanded"
							class="item"
							v-bind:class="{
								completed: item.completed,
								warning: item.type == 'warning',
								failed: item.type == 'failed',
							}">
							<div class="line"></div>
							<div class="circle">
								<SvgIcon v-if="item.completed && item.type == 'item'" name="done" />
								<SvgIcon v-if="item.type == 'warning'" name="exclamation" />
								<SvgIcon v-if="item.type == 'failed'" name="close" />
							</div>
							<div class="text">

								{{ item.name }}
								<div class="note" v-if="item.note || item.inspect">
									{{ item.note }}
									<span class="inspect-link">
										<template v-if="item.inspect && item.note"> | </template>
										<span class="link" v-if="item.inspect" v-on:click="inspectObject(item.inspect)">Inspect</span>
									</span>
								</div>
								<div class="buttons" v-if="item.buttons.length">
									<div class="toggle-buttons" v-on:click="open_button_list = open_button_list == item.name ? false : item.name">
										<div></div>
										<div></div>
										<div></div>
									</div>
									<div class="button-list small-margin-top" v-if="open_button_list == item.name">
										<button class="white smaller" :disabled="saving" v-for="button in item.buttons" v-on:click="executeButton(button)">
											{{ button.name }}
										</button>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

			</div> <!-- End of .groups -->

		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    data: {},
    cancelled: false,
    loading: false,
    saving: false,
    expanded: false,
    open_button_list: false,
    inspect: false
  }),
  computed: {
    usingItems () {
      for (var group of this.data) {
        if (group.items.length) {
          return true
        }
      }

      return false
    },
    expandableItems () {
      var count = 0

      for (var group of this.data) {
        if (group.items.length) {
          for (var item of group.items) {
            if (item.collapsible) {
              count++
            }
          }
        }
      }

      return count
    }
  },
  methods: {
    inspectObject (data) {
      this.inspect = data
    },
    toggleButtonList (item) {
      item._open_button_list = !item._open_button_list
    },
    reload () {
      this.load()
    },
    load () {
      Vue.api.get('/order/' + this.id + '/stage', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data.stage
      this.cancelled = data.cancelled
      this.$emit('loaded')
    },
    executeButton (button) {
      if (button.api_url) {
        if (undefined !== button.method && button.method === 'download') {
          window.open(Vue.api.url(button.api_url), '_blank')
        } else {
          Vue.api.post(button.api_url, {}, {
            before: () => this.saving = true,
            always: () => this.saving = false,
            callback: () => {
              alert('Done!')
              this.reload()
            }
          })
        }
      } else if (button.url) {
        this.$router.push(button.url)
      }
    },
    isWarning (group) {
      if (this.isFailed(group)) {
        return false
      }

      for (var item of group.items) {
        if (item.type == 'warning') {
          return true
        }
      }

      return false
    },
    isFailed (group) {
      for (var item of group.items) {
        if (item.type == 'failed') {
          return true
        }
      }

      return false
    }
  },
  created () {
    this.load()
  }
}
</script>
